<div class="extra-frame">
  <form [formGroup]="UserForm" (ngSubmit)="saveUser(UserForm.value)">
    <div *ngIf="!user.ID">
      <div class="row">
        <div class="col-md-12 label header">{{ 'bikeshop.modal.shared.cyclist-bike.add_cyclist' | translate}}</div>
      </div>
      <div class="row margin-top-8">
        <div
          class="col-md-12 label">{{ 'bikeshop.modal.shedule_service.enter_either_email_or_phone_or_both' | translate }}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-2 label"
             [ngClass]="{'red': !UserForm.value['PhoneNumber'] && (!UserForm.value['Email'] || UserForm.value['Email'].length===0)}">
          <span
            *ngIf="!UserForm.value['PhoneNumber'] || UserForm.value['PhoneNumber'].length===0">*</span>{{ 'general.email' | translate}}
          :
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="text" pInputText formControlName="Email"
                   placeholder="{{ 'general.email' | translate}}" (change)="searchUser($event)"/>
          </div>
        </div>
        <div class="col-md-2 label"
             [ngClass]="{'red': !UserForm.value['Email'] && (!UserForm.value['PhoneNumber'] || UserForm.value['PhoneNumber'].length===0)}">
          <span
            *ngIf="!UserForm.value['Email'] || UserForm.value['Email'].length===0">*</span>{{ 'general.phone_number' | translate}}
          :
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="text" pInputText formControlName="PhoneNumber"
                   placeholder="{{ 'general.phone_number' | translate}}"
                   (change)="searchUserPhone($event)"/>
          </div>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-2 label" [ngClass]="{'red': !UserForm.value['Name'] || UserForm.value['Name'].length===0}">
          *{{ 'general.firstname' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="text" pInputText placeholder="{{ 'general.firstname' | translate}}"
                   formControlName="Name"/>
          </div>
        </div>
        <div class="col-md-2 label"
             [ngClass]="{'red': !UserForm.value['Surname'] || UserForm.value['Surname'].length===0}">
          *{{ 'general.surname' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="text" pInputText placeholder="{{ 'general.surname' | translate}}"
                   formControlName="Surname"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-12 label header">{{ 'bikeshop.modal.shared.cyclist-bike.add_a_bike' | translate}}</div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2 label"
           [ngClass]="{'red': !UserForm.value['Manufacturer'] || UserForm.value['Manufacturer'].length===0}">
        *{{ 'general.manufacturer' | translate}}:
      </div>
      <div class="col-md-4">
        <div class="p-inputgroup">
          <p-autoComplete formControlName="Manufacturer" [suggestions]="manufacturers"
                          placeholder="{{ 'general.manufacturer' | translate}}" [forceSelection]="false"
                          (completeMethod)="searchManufacturer($event)">
            <ng-template let-manufacturer pTemplate="item">
              <div><span>{{manufacturer}}</span></div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
      <div class="col-md-2 label" [ngClass]="{'red': !UserForm.value['Model'] || UserForm.value['Model'].length===0}">
        *{{ 'general.model' | translate}}:
      </div>
      <div class="col-md-4">
        <div class="p-inputgroup">
          <p-autoComplete formControlName="Model" [suggestions]="models"
                          placeholder="{{ 'general.model' | translate}}" [forceSelection]="false"
                          (completeMethod)="searchModel($event)">
            <ng-template let-model pTemplate="item">
              <div><span>{{model}}</span></div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2 label">{{ 'bikeshop.modal.shared.bike.year' | translate}}:</div>
      <div class="col-md-4">
        <div class="p-inputgroup">
          <input type="number" pInputText placeholder="{{ 'bikeshop.modal.shared.bike.year' | translate}}"
                 formControlName="Year" maxlength="4"/>
        </div>
      </div>
      <div class="col-md-2 label">{{ 'general.color' | translate}}:</div>
      <div class="col-md-4">
        <div class="p-inputgroup">
          <input type="text" pInputText placeholder="{{ 'general.color' | translate}}"
                 formControlName="Color"/>
        </div>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2 label">{{ 'bikeshop.modal.shared.bike.serial_no' | translate}}:</div>
      <div class="col-md-4">
        <div class="p-inputgroup">
          <input type="text" pInputText placeholder="{{ 'bikeshop.modal.shared.bike.serial_no' | translate}}"
                 formControlName="SerialNo"/>
        </div>
      </div>
    </div>


    <div class="row margin-top-16">
      <div class="col-md-8"></div>
      <div class="col-md-4">
        <button pButton type="submit" class="p-button-raised approve full-width"
                label="{{user.ID ? ('bikeshop.modal.shared.cyclist-bike.button.add_bike' | translate) : ('bikeshop.modal.shared.cyclist-bike.button.create_cyclist' | translate)}}"
                [disabled]="!UserForm.valid || !valid() || userExists || busy"></button>
      </div>
    </div>
    <div class="row">
      <div *ngIf="error" class="col-md-12 errormessage">{{errorMessage}}</div>
    </div>
  </form>

  <p-confirmDialog></p-confirmDialog>
</div>
